var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkdown = function SvgMarkdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none",
    viewBox: "0 0 24 21"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.89,
    height: 18.25,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 3,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 14.11V7h2.06l2.07 2.61L11.19 7h2.07v7.11h-2.07v-4.08l-2.06 2.62-2.07-2.62v4.08H5Zm12.9 0-3.1-3.45h2.07V7h2.07v3.66H21l-3.1 3.45Z"
  })));
};
export default SvgMarkdown;